export default __webpack_public_path__ + "static/media/07.d05049b1.jpg";